module.exports = __webpack_public_path__ + "media/img/skorzana@3x-dark-64451bc6.svg";